module.exports = __webpack_public_path__ + "media/images/flags/4x3/ltu-3639e1a994c3b663f5a6c79cf4a4419a.svg";